import ReactDOM from 'react-dom/client'
import { hotjar } from 'react-hotjar'
import { Provider } from 'react-redux'
import { IonApp } from '@ionic/react'
import { store } from './Store'
import './app-global-config'
import App from './apps/veterinary/App'
import Wrapper from './wrapper'

hotjar.initialize(3174341, 6)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <IonApp className="safe-top safe-left safe-right safe-bottom">
      <Wrapper>
        <App />
      </Wrapper>
    </IonApp>
  </Provider>
)
